export enum AccountType {
    None = 0,
    CheckingAccount = 1,
    SavingsAccount = 2
}
